import constants from "constants";
import React, { Component } from "react";
import { connect } from "react-redux";
import { loadUpcomingWebinarsSaga } from "../../../../actions/api";
import { cleanWebinars } from "../../../../actions/webinars";
import UpcomingWebinarsContainer from "./UpcomingWebinarsContainer";

const { UPCOMING_WEBINARS } = constants;

class StudyGroupSuperhostUpcomingWebinars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      group_id: props.params.id,
    };
  }

  componentDidMount() {
    this.props.loadUpcomingWebinars(this.state.page, {
      group_id: this.state.group_id,
    });
  }

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  handleNextPage = () =>
    this.setState({ page: this.state.page + 1 }, () =>
      this.props.loadUpcomingWebinars(this.state.page, {
        group_id: this.state.group_id,
      })
    );

  render() {
    return (
      <UpcomingWebinarsContainer
        webinars={this.props.upcoming.values}
        nextPage={this.handleNextPage}
        page={this.state.page}
        count={this.props.upcoming.count}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    upcoming: state.webinars[UPCOMING_WEBINARS],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadUpcomingWebinars: (page, params) =>
      dispatch(loadUpcomingWebinarsSaga(page, params)),
    cleanWebinars: () => dispatch(cleanWebinars()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostUpcomingWebinars);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Upcoming/StudyGroupSuperhostUpcomingWebinars.jsx